import Fields from '@components/fields'
import { Form, Formik } from 'formik'
import React, { useState } from 'react'

const CancleReason = ({ item }) => {
  const [initialState, setInitialState] = useState({
    reason: item.infos.reason,
  })

  return (
    <Formik initialValues={initialState} onSubmit={() => {}}>
      <Form>
        <Fields.TextArea
          name="reason"
          label="Cancellation Reason"
          placeholder="Reason here..."
        />
      </Form>
    </Formik>
  )
}

export default CancleReason
